/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonContactDataViewModel } from "../types/PersonContactDataViewModel.ts";

export const personContactDataViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("Identificador único da pessoa.")),
  email: z
    .string()
    .describe("Endereço de e-mail pessoal da pessoa. Opcional.")
    .nullish(),
  corporateEmail: z
    .string()
    .describe("Endereço de e-mail corporativo da pessoa. Opcional.")
    .nullish(),
  celPhone: z
    .string()
    .describe("Número de celular da pessoa. Opcional.")
    .nullish(),
  homePhone: z
    .string()
    .describe("Número de telefone residencial da pessoa. Opcional.")
    .nullish(),
  workPhone: z
    .string()
    .describe("Número de telefone comercial da pessoa. Opcional.")
    .nullish(),
  fax: z.string().describe("Número de fax da pessoa. Opcional.").nullish(),
  isWhatsapp: z.optional(
    z
      .boolean()
      .describe("Indica se o número de celular cadastrado possui WhatsApp."),
  ),
  receiveSms: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa aceita receber notificações por SMS."),
  ),
  receiveMarketing: z.optional(
    z
      .boolean()
      .describe("Indica se a pessoa aceita receber comunicações de marketing."),
  ),
  site: z
    .string()
    .describe("URL do site pessoal ou profissional da pessoa. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonContactDataViewModel>;
